/**
 * @desc 插件配置文件
 * @auth Vman
 */

import Vue from "vue";
import "@/assets/css/common.css";
import util from "@/utils";

import ElementUI from "element-ui";
import 'element-ui/lib/theme-chalk/index.css';
// import mock from '../mock/index'
import vuescroll from "vuescroll";
import "vuescroll/dist/vuescroll.css";
import store from "@/store";

import mapUtil from "../utils/mapIndex/index";
import ft from "@/utils/filter";
import htmlToPdf from "@/utils/htmlToPdf";

const mapList = mapUtil.init();
let map = ft.buildMap(mapList);
store.dispatch("addFilterMap", map);

import NProgress from "nprogress"; // nprogress插件
import "nprogress/nprogress.css"; // nprogress样式
NProgress.inc(0.2);
NProgress.configure({ easing: "ease", speed: 1000, showSpinner: true }); //showSpinner:false 关闭进度环

Vue.use(htmlToPdf);
Vue.use(vuescroll);
Vue.use(ElementUI);
Vue.prototype.$util = util;
//模拟数据
// Vue.use(mock);
export default Vue;
